/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneArticleHeader as ResolvedStandaloneArticleHeader } from 'base/components/standalone/ArticleHeader';

export const ArticleHeader: typeof ResolvedStandaloneArticleHeader = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneArticleHeader {...props} />
    );
});

export type ArticleHeaderProps = PropsFromComponent<typeof ArticleHeader>;

/** @deprecated Use slot architecture instead */
export const ArticleHeaderWith = (extras: DynamicStandaloneExtras): typeof ArticleHeader => {
    return function ArticleHeader(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ArticleHeader');
        return <ResolvedStandaloneArticleHeader {...mergeProps({ options: { theme } }, props)} />;
    }
}